import React, { FC, useState } from "react";
import { useTranslations } from "next-intl";
import {
  FlightIcon,
  HotelIcon,
  SolidFlightIcon,
  SolidHotelIcon,
} from "@/components/icons";
import HotelSearchForm from "../HotelSearchForm/HotelSearchForm";
import { Card, CardContent, useMediaQuery } from "@mui/material";

// import ActivitiesIcon from "@/components/icons/ActivitiesIcon/ActivitiesIcon";
// import SolidActivitiesIcon from "@/components/icons/SolidActivitiesIcon/SolidActivitiesIcon";
import FlightsForm from "../FlightsForm/FlightsForm";
interface SearchFormProps {
  onCloseEditSearch?: () => void;
  loading?: () => void;
}

const NewSearchForm: FC<SearchFormProps> = ({ onCloseEditSearch, loading }) => {
  const t = useTranslations();
  const [selectedTab, setSelectedTab] = useState("hotel");
  const isMobile = useMediaQuery("(max-width:992px)");

  const travelOptions = [
    {
      id: "flight",
      label: t("searchForm.flight"),
      icon: <FlightIcon className="text-white " />,
      activeIcon: <FlightIcon className="text-primary" />,
      component: (
        <FlightsForm />
      ),
    },
    {
      id: "hotel",
      label: t("searchForm.hotel"),
      icon: <HotelIcon className="text-white" />,
      activeIcon: <HotelIcon className="text-primary" />,
      component: (
        <HotelSearchForm
          loading={loading} 
          onCloseEditSearch={onCloseEditSearch}
        />
      ),
    },
    // {
    //   id: "activites",
    //   label: t("searchForm.activites"),
    //   icon: <ActivitiesIcon />,
    //   activeIcon: <SolidActivitiesIcon />,
    //   component: <ActivitiesForm />,
    // },
  ];

  return (
    <div className="w-full relative  flex flex-row   justify-center bg-[url('/images/hero-bg.png')]  h-[480px] bg-cover [background-position-y:-55px] mb-28">
      {/* //   <div className="w-full max-w-[1312px] relative ">
    //     <Frame />
    //     <Frame2 />

    //     <div className="absolute w-44 h-44 bottom-[74px] ltr:left-[-80px] rtl:right-[-80px] bg-[#FFEFD880] rounded-full" />

    //     <div className="flex flex-col w-full max-w-[800px] items-start  !z-10 mt-20">
    //       <h1 className="text-4xl font-bold mb-8 leading-[48px] text-primary ">
    //         {t("searchForm.title")}
    //       </h1>

    //       <div className="c-lg:w-[800px] z-[1]  w-full max-c-lg:mt-12 max-c-lg:px-4">
    //         <div className="flex flex-col  bg-white rounded-3xl c-lg:min-h-[380px] c-lg:h-fit h-[530px]  c-lg:w-[800px] w-full shadow-[0px_12px_32px_-2px_#00000029,0px_10px_8px_-5px_#00000029,0px_2px_8px_#00000029,0px_-1px_0px_#00000008]">
    //           <div className="flex gap-4 p-4 ">
    //             {travelOptions.map((option) => (
    //               <button
    //                 key={option.id}
    //                 type="button"
    //                 onClick={() => setSelectedTab(option.id)}
    //                 className={`flex items-center gap-2 h-11 px-4 rounded-full ${
    //                   selectedTab === option.id
    //                     ? "bg-[#e8f2ff] border border-primary text-primary font-bold"
    //                     : "bg-transparent text-primary font-thin"
    //                 }`}
    //               >
    //                 {selectedTab === option.id
    //                   ? option.activeIcon
    //                   : option.icon}
    //                 {option.label}
    //               </button>
    //             ))}
    //           </div>

    //           {selectedTab === "hotel" ? (
    //             <HotelSearchForm
    //               loading={loading}
    //               onCloseEditSearch={onCloseEditSearch}
    //             />
    //           ) : (
    //             <FlightsForm />
    //           )}
    //         </div>
    //       </div>
    //     </div>

    //     <div className="absolute w-[438px] h-[408px] top-[140px] ltr:right-0 rtl:left-0">
    //       <div className="absolute ltr:min-w-[250px] rtl:min-w-[260px] h-[97px] top-[40%] ltr:right-[30%] rtl:left-[30%] z-[2] ">
    //         {" "}
    //         <Card className="ltr:min-w-[250px] rtl:min-w-[260px] h-[97px]  !rounded-[20px] ">
    //           {" "}
    //           <CardContent className="relative w-full flex flex-row-reverse items-center justify-between h-full gap-5  !p-4 !bg-primary !border-white !border-2 !rounded-[20px] !shadow-none">
    //             {" "}
    //             <div className="  text-wrap flex items-center font-bold text-white text-xl   leading-[normal]">
    //               <div
    //                 dangerouslySetInnerHTML={{
    //                   __html: t("Get The almuayed App"),
    //                 }}
    //               ></div>
    //             </div>{" "}
    //             <div className=" w-[65px] h-[65px] p-1  bg-white rounded-[10px] flex items-center justify-center">
    //               {" "}
    //               <img
    //                   className="w-[57px] h-[57px] object-cover"
    //                   alt=""
    //                   src={"/images/qr.png"}
    //                 />{" "}
    //             </div>{" "}
    //           </CardContent>{" "}
    //         </Card>{" "}
    //       </div>

    //       <div className="w-[680px] h-[510px] rounded-[45%] absolute top-[-65px] ltr:right-[-80px] rtl:left-[10px] rtl:scale-x-[-1]">
    //         <img
    //           src="/images/home-bg.webp"
    //           alt="People traveling"
    //           className="w-full h-full object-cover rounded-[40%]"
    //         />
    //       </div>
    //     </div>
    //   </div> */}

      <div className="flex flex-col h-[400px] items-center justify-end gap-[38px] relative  ">
        {/* Header */}
        <div className="flex-wrap flex-col  w-full gap-[0px_0px] pt-16 pb-0  flex-[0_0_auto] flex items-start relative">
          <p className="relative flex items-center justify-center font-bold text-white text-[34px] tracking-[0] leading-[52px]">
            Your next adventure starts now
          </p>

          <p className="relative flex items-center justify-center  font-semibold text-white text-lg tracking-[0] leading-7">
            Choose from over 1.5 million hotels &amp; 450+ airline
          </p>
        </div>

        {/* Tabs */}
        <div className="flex-col w-[1312px] flex-[0_0_auto] flex items-start relative">
          <div className="flex-col pt-px pb-0 px-0 self-stretch w-full flex-[0_0_auto] flex items-start relative">
            <div className="min-h-12 justify-center self-stretch w-full flex-[0_0_auto] flex items-start relative">
              <div className="flex-col flex-1 self-stretch grow flex items-start relative">
                <nav
                  className="flex items-start relative self-stretch w-full flex-[0_0_auto]"
                  role="tablist"
                  aria-label="Booking options"
                >
                  {travelOptions.map((tab) => {
                    const isActive = selectedTab === tab.id;

                    const padding =
                      tab.id === "flights"
                        ? "pl-[21.89px] pr-[26.86px] py-[7.03px]"
                        : tab.id === "stays"
                          ? "px-[30.16px] py-[11px]"
                          : "pl-[18.31px] pr-[18.33px] py-3";

                    return (
                      <div
                        key={tab.id}
                        className="inline-flex flex-col min-w-[132px] max-w-[362px] min-h-12 items-start pl-0 pr-0.5 py-0 relative flex-[0_0_auto]"
                      >
                        <button
                          type="button"
                          role="tab"
                          aria-selected={isActive}
                          aria-controls={`${tab.id}-panel`}
                          id={`${tab.id}-tab`}
                          onClick={() => setSelectedTab(tab.id)}
                          className={`
                          ${padding}
                          ${
                            isActive
                              ? "bg-white border border-solid"
                              : "bg-[#00000066]"
                          }
                          inline-flex min-w-[130px] max-w-[360px] min-h-12
                          items-center justify-center relative flex-[0_0_auto]
                          rounded-[8px_8px_0px_0px] overflow-hidden gap-[3.03px]
                        `}
                        >
                          {/* {tab.id === "flights" && (
                          <div className="inline-flex flex-col h-[33.94px] items-center justify-center relative flex-[0_0_auto]">
                            <div className="-rotate-45 relative w-6 h-6">
                              <img
                                className="h-[81.34%] top-[12.28%] left-[6.43%] rotate-45 absolute w-[81.25%]"
                                alt=""
                                src={tab.icon}
                              />
                            </div>
                          </div>
                        )}

                        {tab.id === "stays" && (
                          <div className="flex flex-col items-start pl-0 pr-2 py-0 w-8 h-6 relative">
                            <div className="flex flex-col items-center justify-center relative w-6 h-6">
                              <div className="relative flex-1 w-6 grow">
                                <img
                                  className="h-[62.50%] top-[16.67%] left-[7.29%] absolute w-[81.25%]"
                                  alt=""
                                  src={tab.icon}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {tab.id === "activities" && (
                          <img
                            className="w-8 h-6 relative"
                            alt=""
                            src={tab.icon}
                          />
                        )} */}
                          {selectedTab === tab.id ? tab.activeIcon : tab.icon}

                          <div
                            className={`
                            relative flex items-center justify-center w-fit
                            [font-family:'Open_Sans-SemiBold',Helvetica]
                            font-semibold text-sm text-center tracking-[0]
                            leading-5 whitespace-nowrap
                            ${isActive ? "text-[#003143]" : "text-white"}
                          `}
                          >
                            {tab.label}
                          </div>
                        </button>
                      </div>
                    );
                  })}
                </nav>
              </div>
            </div>
            <div
              className="relative self-stretch w-full min-h-[104px] -mt-px bg-white rounded-[0px_8px_8px_8px] flex items-center"
              role="tabpanel"
              id={`${selectedTab}-panel`}
              aria-labelledby={`${selectedTab}-tab`}
            >
{
              travelOptions.find((option) => option.id === selectedTab)
                ?.component                                       


}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSearchForm;
